import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from "react-router";
import Qs from 'query-string'

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

import Loading from 'components/Loading'
import Block from 'components/common/Block'
import UserInfoTable from './table/UserInfoTable'
import FeeTable from './table/FeeTable'
import PaymentTable from './table/PaymentTable'
import ReceiptInfoTable from './table/ReceiptInfoTable'
import ShippingTable from './table/ShippingTable'
import OutBoundFeeTable from './table/OutBoundFeeTable'
import Footer from 'components/common/Footer'
import OrderItemList from 'components/common/OrderItemList'

import { formatDate } from 'libraries/utils'

import {
    getOrderInfo,
    orderCreditCardPayment,
    getCoupons,
} from '../../actions/asyncOrders'

class OrderDetail extends Component {
	constructor(props){
        super(props);
        const search = Qs.parse(window.location.search);
        this.orderId = search.orderId || props.location.state
    }

    componentDidMount(){
        this.props.getOrderInfo(this.orderId)
        this.props.getCoupons()
    }

    componentWillReceiveProps(nextProps){
        const { updateCreditCardSucc, orderCreditCardPaymentSucc } = this.props

        // 更新信用卡後重新付款
        if(!updateCreditCardSucc && nextProps.updateCreditCardSucc){
            this.props.orderCreditCardPayment(this.orderId)
        }

        // 重新付款後 重新取得付款資訊
        if(!orderCreditCardPaymentSucc && nextProps.orderCreditCardPaymentSucc){
            this.props.getOrderInfo(this.orderId)
        }
    }

	render() {
        const { t, orderInfo, isLoading, memberInfo, coupons, orderCreditCardPayment } = this.props
        const serviceAction = orderInfo.get('serviceAction')

        if(!orderInfo.size){
            return (<Loading isLoading={true} />)
        }

		return (
			<Grid container justify="center" className="main-contaienr order-detail">
				<Loading isLoading={isLoading} />
				<Grid item md={8}>
					{/* header */}
					<Grid container justify="space-between" >
						<Typography variant="h1">
							{formatDate(orderInfo.get('createdAt'))} {t(`${serviceAction}_fee`)}
						</Typography>
						<Typography>{t('order_number')}：{orderInfo.get('orderNo')}</Typography>
					</Grid>

                    {/* 用戶資訊 */}
					<Block
                        title={t('user_info')}
                        contClassname="bg-white"
                    >
						<UserInfoTable data={orderInfo}/>
					</Block>

                    {/* 使用紀錄明細 */}
					<Block
                        title={t('fee_datail')}
                        contClassname="bg-white"
                    >
                        {serviceAction === 'storage' ?
                            <FeeTable data={orderInfo}/>
                            :  <OutBoundFeeTable data={orderInfo} coupons={coupons}/>
                        }
					</Block>

                    {/* 付款資訊 */}
                    <Block
                        title={t('payment_info')}
                        contClassname="bg-white"
                    >
						<PaymentTable
                            data={orderInfo}
                            orderId={this.orderId}
                            orderCreditCardPayment={orderCreditCardPayment}
                            memberInfo={memberInfo}
                        />
					</Block>

                    {/* 發票資訊 */}
                    <Block
                        title={t('receipt_info')}
                        contClassname="bg-white"
                    >
						<ReceiptInfoTable data={orderInfo} />
					</Block>

                    {/* 物流資訊: 出窖費用 */}
                    {serviceAction === 'out_bound' &&
                        <Block
                            title={t('shipping_info')}
                            contClassname="bg-white"
                        >
    						<ShippingTable data={orderInfo} />
    					</Block>
                    }

                    {/* footer */}
                    <Footer />

                    {/* wine image */}
                    <Grid container style={{marginTop: '70px'}}>
                        <OrderItemList
							orderId={this.orderId}
						/>
					</Grid>
				</Grid>
			</Grid>
		)
	}
}

const mapStateToProps = state => ({
    isLoading: state.orders.isLoading,
    orderInfo: state.orders.orderInfo,
    memberInfo: state.member.member,
    updateCreditCardSucc: state.member.updateCreditCardSucc,
    coupons: state.orders.coupons,
})

const mapDispatchToProps = {
    getOrderInfo,
    orderCreditCardPayment,
    getCoupons,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(withTranslation()(OrderDetail)))
